import { Button, Card, Stack } from "@shopify/polaris";
import { Field } from "react-final-form";
import AttributeConditions from "../../../../Conditions/AttributeConditions/AttributeConditions.js";
import { ATTRIBUTE_TITLE } from "../../../../../../../../../../../../constants/attributeTypes.js";
import { ATTRIBUTE_QUALIFIER_EQUAL } from "../../../../../../../../../../../../constants/attributeQualifierTypes.js";
import { FieldArray } from "react-final-form-arrays";
import styles from "../MultipleConditionsCard.module.css";

const ConditionsCard = ({ multipleCondition }) => {

  return (
    <Card>
      <Card.Section>
        <FieldArray name={`${multipleCondition}.conditions[]`}>
          {({ fields }) => (
            <Stack vertical key={`${multipleCondition}.conditions[]`}>
              {fields.map((condition, index) => {
                return (
                  <Stack vertical key={condition}>
                    <Field name={condition} component={AttributeConditions} isMultiple />
                    <Stack distribution={"trailing"} alignment={"center"}>
                      <Button
                        plain
                        removeUnderline
                        onClick={() => fields.remove(index)}
                      >
                        Delete criteria
                      </Button>
                    </Stack>
                    {fields.length !== index + 1 &&
                      <div className={styles["text-between"]}>
                        AND
                      </div>
                    }
                  </Stack>
                );
              })}
              <Button
                onClick={() => fields.push({
                  attribute: ATTRIBUTE_TITLE,
                  qualifier: ATTRIBUTE_QUALIFIER_EQUAL,
                  value: ""
                })}
              >
                AND
              </Button>
            </Stack>
          )}
        </FieldArray>
      </Card.Section>
    </Card>
  );
};

export default ConditionsCard;